export enum CardKind {
  Credit = 'Credit',
  Debit = 'Debit',
}
